import { useEffect, useState } from "react";
import style from "./Settings.module.css";
import AdminNavbar from "../NavBar/AdminNavBar";
import { Link, useParams } from "react-router";

export default function Settings() {
    const { employeeId } = useParams(); // comes from route like /settings/emp001

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        dob: "",
        gender: "",
        position: "",
        teamName: "",
        phone: "",
        altPhone: "",
        address: "",
        linkedin: "",
        github: "",
        x: "",
        email: "",
        password: "",
    });

    const [Loading, setLoading] = useState(true);
    const apiurl = process.env.REACT_APP_SERVER_URL
    const token = localStorage.getItem("token");

    // Fetch user data by employeeId
    useEffect(() => {
        async function fetchUser() {
            try {
                const res = await fetch(`${apiurl}/employee-dashboard/${employeeId}`, {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    }
                });
                if (!res.ok) throw new Error("Failed to fetch user data");

                const data = await res.json();
                const user = data.user;

                setFormData({
                    firstName: user.firstName || "",
                    lastName: user.lastName || "",
                    dob: user.dob ? user.dob.split("T")[0] : "",
                    gender: user.gender || "",
                    position: user.position || "",
                    teamName: user.teamName || "",
                    phone: user.phonePrimary?.toString() || "",
                    altPhone: user.phoneSecondary?.toString() || "",
                    address: user.address || "",
                    linkedin: user.socialLinks?.linkedIn || "",
                    github: user.socialLinks?.github || "",
                    x: user.socialLinks?.x || "",
                    email: user.email || "",
                    password: "", // don't prefill password
                });

                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        }

        if (employeeId) {
            fetchUser();
        }
    }, [employeeId, apiurl, token]);

    // Handle input changes
    function handleChange(e) {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    }

    // Submit update
    async function handleSubmit(e) {
        e.preventDefault();
        try {
            const res = await fetch(`${apiurl}/admin-dashboard/${employeeId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(formData),
            });
            if (res.ok) {
                alert("Profile updated successfully!");
            } else {
                alert("Failed to update profile.");
            }
        } catch (error) {
            console.error("Error updating user:", error);
        }
    }

    return (
        <>
            <div className={style.setting}>
                <div className="container">

                    <AdminNavbar />
                    <div className="mt-lg-4 ps-lg-5 ms-lg-5 pb-lg-0">
                        <span>
                            <Link
                                to={`/admin-dashboard/${employeeId}`} className={style.breadcrumb} style={{ textDecoration: 'none' }}>
                                Dashboard
                                <i className="ps-1 pe-1 bi bi-caret-right-fill"></i>
                            </Link>
                        </span>

                        <span>
                            <Link
                                to={`/admin-dashboard/${employeeId}/settings`}
                                style={{ textDecoration: 'none' }}
                                className={style.breadcrumb}
                            >
                                Update Your Profile For {employeeId}
                            </Link>
                        </span>
                    </div>

                    {Loading && <p>{Loading}</p>}
                    <div className={`container ${style.settingsPage}`}>
                        <form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                {/* First and Last Name */}
                                <div className="col-6 col-md-6">
                                    <input
                                        type="text"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        className={`form-control ${style.input}`}
                                        placeholder="Enter first name"
                                    />
                                </div>
                                <div className="col-6 col-md-6">
                                    <input
                                        type="text"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        className={`form-control ${style.input}`}
                                        placeholder="Enter last name"
                                    />
                                </div>

                                {/* Email and DOB */}
                                <div className="col-6 col-md-6">
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className={`form-control ${style.input}`}
                                        placeholder="Enter email"
                                        disabled
                                    />
                                </div>
                                <div className="col-6 col-md-6">
                                    <input
                                        type="date"
                                        name="dob"
                                        value={formData.dob}
                                        onChange={handleChange}
                                        className={`form-control ${style.input}`}
                                    />
                                </div>

                                {/* Gender, Position, Team */}
                                <div className="row  mt-3">
                                    <div className="col-4 col-lg-4  mt-1">
                                        <select
                                            name="gender"
                                            value={formData.gender}
                                            onChange={handleChange}
                                            className={`form-select ${style.formSelect}`}
                                            required
                                        >
                                            <option value="">Select Gender</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                    <div className="col-4 col-lg-4 mt-1">
                                        <select
                                            name="position"
                                            className={`form-select ${style.formSelect} w-100 `}
                                            value={formData.position}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">position</option>
                                            <option value="Head Admin">Head Admin</option>
                                            <option value="Junior Admin">Junior Admin</option>
                                            <option value="Head Manager">Head Manager</option>
                                            <option value="Hr">Hr</option>
                                            <option value="Front End Developer">Front End Developer</option>
                                            <option value="UI Designer">UI Designer</option>
                                            <option value="React Developer">React Developer</option>
                                            <option value="NodeJS Developer">NodeJS Developer</option>
                                            <option value="MERN Developer">MERN Developer</option>
                                            <option value="MEAN Developer">MEAN Developer</option>
                                            <option value="Database Developer">Database Developer</option>
                                            <option value="Manual Tester">Manual Tester</option>
                                            <option value="Automation Tester">Automation Tester</option>
                                        </select>
                                    </div>
                                    <div className="col-4 col-lg-4 mt-1">
                                        <select
                                            name="teamName"
                                            className={`form-select ${style.formSelect}`}
                                            value={formData.teamName}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Team</option>
                                            <option value="Admin Team">Admin Team</option>
                                            <option value="Management Team">Management Team</option>
                                            <option value="Hr Team">Hr Team</option>
                                            <option value="Front End Developement">Front End Developement</option>
                                            <option value="UI/UX Desgin">UI/UX Desgin</option>
                                            <option value="Back End Developement">Back End Developement</option>
                                            <option value="Full Stack Development">Full Stack Development</option>
                                            <option value="DevOps">DevOps</option>
                                            <option value="Q/A Testing">Q/A Testing</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Phone */}
                                <div className="col-6 col-md-6">
                                    <input
                                        type="text"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className={`form-control ${style.input}`}
                                        placeholder="Enter phone number"
                                    />
                                </div>

                                {/* Alternate Phone and Address */}
                                <div className="col-6 col-md-6">
                                    <input
                                        type="text"
                                        name="altPhone"
                                        value={formData.altPhone}
                                        onChange={handleChange}
                                        className={`form-control ${style.input}`}
                                        placeholder="Enter alternate phone"
                                    />
                                </div>
                                <div className="col-12 col-md-12">
                                    <input
                                        type="text"
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                        className={`form-control ${style.input}`}
                                        placeholder="Enter address"
                                    />
                                </div>
                                <div className="d-md-none d-lg-block d-xl-none">
                                    <div className="row">

                                        <div className="col-6 col-md-4">
                                            <input
                                                type="text"
                                                name="linkedin"
                                                value={formData.linkedin}
                                                onChange={handleChange}
                                                className={`form-control ${style.input}`}
                                                placeholder="LinkedIn profile"
                                            />
                                        </div>
                                        <div className="col-6">
                                            <input
                                                type="text"
                                                name="github"
                                                value={formData.github}
                                                onChange={handleChange}
                                                className={`form-control ${style.input}`}
                                                placeholder="GitHub profile"
                                            />
                                        </div>
                                        <div className="col-6 col-md-4 mt-3">
                                            <input
                                                type="text"
                                                name="x"
                                                value={formData.x}
                                                onChange={handleChange}
                                                className={`form-control ${style.input}`}
                                                placeholder="X handle"
                                            />
                                        </div>
                                        <div className="col-6  mt-3">
                                            <input
                                                type="password"
                                                name="password"
                                                value={formData.password}
                                                onChange={handleChange}
                                                className={`form-control ${style.input}`}
                                                placeholder="Enter new password"
                                            />
                                        </div>
                                    </div>

                                </div>

                                {/* Social Links */}
                                <div className=" d-none d-lg-block">
                                    <div className="row mt-1">

                                        <div className=" col-6 col-md-4">
                                            <input
                                                type="text"
                                                name="linkedin"
                                                value={formData.linkedin}
                                                onChange={handleChange}
                                                className={`form-control ${style.input}`}
                                                placeholder="LinkedIn profile"
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <input
                                                type="text"
                                                name="github"
                                                value={formData.github}
                                                onChange={handleChange}
                                                className={`form-control ${style.input}`}
                                                placeholder="GitHub profile"
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <input
                                                type="text"
                                                name="x"
                                                value={formData.x}
                                                onChange={handleChange}
                                                className={`form-control ${style.input}`}
                                                placeholder="X handle"
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Password */}
                                <div className="col-md-6 d-none">
                                    <input
                                        type="password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        className={`form-control ${style.input}`}
                                        placeholder="Enter new password"
                                    />
                                </div>
                            </div>

                            <div className="text-center mt-4">
                                <button type="submit" className="btn btn-primary px-4">
                                    Save Changes
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </>
    );
}
